<template>
  <div>
    <!--Header-->
    <div class="header pb-6 d-flex align-items-center">
      <!-- Mask -->
      <span class="mask bg-default opacity-8"></span>
    </div>
    <section class="section section-lg pt-4 pb-2 bg-white">
      <b-container>
        <h3 class="mb-0">Video Library</h3>
        <p class="small">Here you will find helpful videos to get the full benefit of ClarityNOW.</p>
        <b-row class="justify-content-center">
          <b-col md="3" v-if="owner || agent" class="text-center">
            <b-button block size="lg" variant="outline-danger" @click="goToDashboard" class="mb-2">
              <div class="mb-2">
                <i class="fas fa-2x fa-tachometer-alt text-black"></i>
              </div>
              Portal Dashboard
            </b-button>
          </b-col>
          <b-col md="3" class="text-center">
            <b-button block size="lg" variant="outline-danger" :to="'/observatory'" class="mb-2">
              <div class="mb-2">
                <i class="fas fa-2x fa-eye text-black"></i>
              </div>
              Observatory
            </b-button>
          </b-col>
        </b-row>
      </b-container>
    </section>
    <section class="section section-lg mt-5">
      <b-container>
        <div class="accordion" role="tablist">
          <b-card no-body class="mb-1">
            <b-card-header header-tag="header" class="p-1" role="tab">
              <b-button block v-b-toggle.accordion-1 variant="outline-danger">How To Videos</b-button>
            </b-card-header>
            <b-collapse id="accordion-1" visible accordion="my-accordion" role="tabpanel">
              <b-card-body no-body>
                <b-tabs content-class="mt-3" v-if="loaded">
                  <b-tab title="Economic Model" active>
                    <b-row class="mt-4">
                      <b-col md="4" v-for="(video, index) in economicModelVideos" :key="index">
                        <b-card overlay :title="video.name" :img-src="video.pictures.base_link" text-variant="white" @click="playVideo(video.player_embed_url, video.name)">
                          <b-card-text class="text-center">
                            <i class="fas fa-2x fa-play mt-3"></i>
                          </b-card-text>
                        </b-card>
                      </b-col>
                    </b-row>
                  </b-tab>
                  <b-tab title="Pipeline">
                    <b-row class="mt-4">
                      <b-col md="4" v-for="(video, index) in pipelineVideos" :key="index">
                        <b-card overlay :title="video.name" :img-src="video.pictures.base_link" text-variant="white" @click="playVideo(video.player_embed_url, video.name)">
                          <b-card-text class="text-center">
                            <i class="fas fa-2x fa-play mt-3"></i>
                          </b-card-text>
                        </b-card>
                      </b-col>
                    </b-row>
                  </b-tab>
                  <b-tab title="Listings & Transactions">
                    <b-row class="mt-4">
                      <b-col md="4" v-for="(video, index) in transactionVideos" :key="index">
                        <b-card overlay :title="video.name" :img-src="video.pictures.base_link" text-variant="white" @click="playVideo(video.player_embed_url, video.name)">
                          <b-card-text class="text-center">
                            <i class="fas fa-2x fa-play mt-3"></i>
                          </b-card-text>
                        </b-card>
                      </b-col>
                    </b-row>
                  </b-tab>
                </b-tabs>
                <loading-panel v-else></loading-panel>
              </b-card-body>
            </b-collapse>
          </b-card>
        </div>
      </b-container>
    </section>
    <b-modal size="lg" id="video-modal" :title="videoTitle" hide-footer>
      <div style='padding:45.47% 0 0 0;position:relative;'><iframe :src="currentVideo" allowfullscreen frameborder='0' style='position:absolute;top:0;left:0;width:100%;height:100%;'></iframe></div>
    </b-modal>
  </div>
</template>

<script>
import axios from 'axios';
import errorsMixin from '@/mixins/errors-mixin';
import LoadingPanel from '@/components/LoadingPanel';

export default {
  mixins: [errorsMixin],
  components: {
    LoadingPanel
  },
  data() {
    return {
      economicModelVideos: null,
      pipelineVideos: null,
      transactionVideos: null,
      currentVideo: null,
      videoTitle: null
    }
  },
  computed: {
    user() {
      return this.$store.getters['profile/user'];
    },
    roles() {
      return this.$store.getters['roles/roles'];
    },
    owner() {
      return this.roles.includes('owner');
    },
    agent() {
      return this.roles.includes('agent');
    },
    loaded() {
      return this.economicModelVideos && this.pipelineVideos && this.transactionVideos;
    }
  },
  methods: {
    async goToDashboard() {
      await this.$router.push({ path: "/dashboard" });
    },
    async getEconomicModelVideos() {
      await axios.get(process.env.VUE_APP_API_BASE_URL + "/videos/economic-model")
      .then(response => {
        this.economicModelVideos = response.data;
      })
      .catch(error => {
        this.error(error);
      });
    },
    async getPipelineVideos() {
      await axios.get(process.env.VUE_APP_API_BASE_URL + "/videos/pipelines")
      .then(response => {
        this.pipelineVideos = response.data;
      })
      .catch(error => {
        this.error(error);
      });
    },
    async getTransactionVideos() {
      await axios.get(process.env.VUE_APP_API_BASE_URL + "/videos/transactions")
      .then(response => {
        this.transactionVideos = response.data;
      })
      .catch(error => {
        this.error(error);
      });
    },
    playVideo(video, title) {
      this.videoTitle = title;
      this.currentVideo = video;
      this.$bvModal.show('video-modal');
    }
  },
  created() {
    this.getEconomicModelVideos();
    this.getPipelineVideos();
    this.getTransactionVideos();
  }
};
</script>
<style lang="scss">
.nav-tabs {
  .nav-link {
    font-weight: bold;
    &:hover {
      color: #dc3545;
    }
    &.active {
      background-color: #dc3545;
      color: #ffffff;
    }
  }
}
.card-title {
  margin-bottom: 0;
}
.card-img-overlay {
  background-color: rgba(0, 0, 0, .4);
  padding-top: .5rem;
  h4 {
    color: #ffffff;
    text-align: center;
    font-size: 1.2rem;
  }
}
</style>